import { useQuery } from '@tanstack/react-query';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { format } from 'date-fns';
import { db } from '@/config/firebase';
import type { CollaboratorPublic } from '@/features/Collaborators/Data';

export function useAllocationManagersQuery() {
  const queryFn = async (): Promise<CollaboratorPublic[]> => {
    const today = format(new Date(), 'yyyy-MM-dd');
    const q = query(
      collection(db, 'collaborators_public'),
      where('allocationManagerUntil', '>=', today)
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({
      ...(doc.data() as CollaboratorPublic),
      id: doc.id,
    }));
  };

  const today = format(new Date(), 'yyyy-MM-dd');

  return useQuery({
    queryKey: ['allocationManagers', today],
    queryFn,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
